const FETCH_ENTITY_REQUEST = 'FETCH_ENTITY_REQUEST';
const FETCH_ENTITY_SUCCESS = 'FETCH_ENTITY_SUCCESS';
const FETCH_ENTITY_ERROR = 'FETCH_ENTITY_ERROR';
const SHOW_MERCHANT_LOADER = 'SHOW_MERCHANT_LOADER';
const HIDE_MERCHANT_LOADER = 'HIDE_MERCHANT_LOADER';
const FETCH_FORM_DETAILS_REQUEST = 'FETCH_FORM_DETAILS_REQUEST';
const FETCH_FORM_DETAILS_SUCCESS = 'FETCH_FORM_DETAILS_SUCCESS';
const FETCH_FORM_DETAILS_ERROR = 'FETCH_FORM_DETAILS_ERROR';
const FETCH_FORM_IN_PROCESS_REQUEST = 'FETCH_FORM_IN_PROCESS_REQUEST';
const FETCH_FORM_IN_PROCESS_SUCCESS = 'FETCH_FORM_IN_PROCESS_SUCCESS';
const FETCH_FORM_IN_PROCESS_ERROR = 'FETCH_FORM_IN_PROCESS_ERROR';
const FETCH_ENTITY_LIST_MERCHANT_REQUEST = 'FETCH_ENTITY_LIST_MERCHANT_REQUEST';
const FETCH_ENTITY_LIST_MERCHANT_SUCCESS = 'FETCH_ENTITY_LIST_MERCHANT_SUCCESS';
const FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST = 'FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST';
const FETCH_ENTITY_LIST_MERCHANT_ERROR = 'FETCH_ENTITY_LIST_MERCHANT_ERROR';
const FETCH_ENTITY_HIERARCHY_REQUEST = 'FETCH_ENTITY_HIERARCHY_REQUEST';
const FETCH_ENTITY_HIERARCHY_SUCCESS = 'FETCH_ENTITY_HIERARCHY_SUCCESS';
const FETCH_ENTITY_HIERARCHY_ERROR = 'FETCH_ENTITY_HIERARCHY_ERROR';
const SAVE_AND_CONTINUE_REQUEST = 'SAVE_AND_CONTINUE_REQUEST';
const SAVE_AND_CONTINUE_SUCCESS = 'SAVE_AND_CONTINUE_SUCCESS';
const SAVE_AND_CONTINUE_ERROR = 'SAVE_AND_CONTINUE_ERROR';
const CREATE_ENTITY_REQUEST = 'CREATE_ENTITY_REQUEST';
const CREATE_ENTITY_SUCCESS = 'CREATE_ENTITY_SUCCESS';
const CREATE_ENTITY_ERROR = 'CREATE_ENTITY_ERROR';
const FETCH_PAYMENT_MODES_REQUEST = 'FETCH_PAYMENT_MODES_REQUEST';
const FETCH_PAYMENT_MODES_SUCCESS = 'FETCH_PAYMENT_MODES_SUCCESS';
const FETCH_PAYMENT_MODES_ERROR = 'FETCH_PAYMENT_MODES_ERROR';
const FETCH_SURCHARGE_SLABS_REQUEST = 'FETCH_SURCHARGE_SLABS_REQUEST';
const FETCH_SURCHARGE_SLABS_SUCCESS = 'FETCH_SURCHARGE_SLABS_SUCCESS';
const FETCH_SURCHARGE_SLABS_ERROR = 'FETCH_SURCHARGE_SLABS_ERROR';
const FETCH_DEFAULT_ROUTING_REQUEST = 'FETCH_DEFAULT_ROUTING_REQUEST';
const FETCH_DEFAULT_ROUTING_SUCCESS = 'FETCH_DEFAULT_ROUTING_SUCCESS';
const FETCH_DEFAULT_ROUTING_ERROR = 'FETCH_DEFAULT_ROUTING_ERROR';
const SET_UNIQUE_IDENTIFIER_REQUEST = 'SET_UNIQUE_IDENTIFIER_REQUEST';
const SET_UNIQUE_IDENTIFIER_SUCCESS = 'SET_UNIQUE_IDENTIFIER_SUCCESS';
const SET_UNIQUE_IDENTIFIER_ERROR = 'SET_UNIQUE_IDENTIFIER_ERROR';
const FETCH_ENTITY_HIERARCHY_MLE_REQUEST = 'FETCH_ENTITY_HIERARCHY_MLE_REQUEST';
const FETCH_ENTITY_HIERARCHY_MLE_SUCCESS = 'FETCH_ENTITY_HIERARCHY_MLE_SUCCESS';
const FETCH_ENTITY_HIERARCHY_MLE_ERROR = 'FETCH_ENTITY_HIERARCHY_MLE_ERROR';
const SUBMIT_FORM_REQUEST = 'SUBMIT_FORM_REQUEST';
const SUBMIT_FORM_SUCCESS = 'SUBMIT_FORM_SUCCESS';
const SUBMIT_FORM_ERROR = 'SUBMIT_FORM_ERROR';
const FETCH_ENTITY_LIST_MERCHANT_MLE_REQUEST =
    'FETCH_ENTITY_LIST_MERCHANT_MLE_REQUEST';
const FETCH_ENTITY_LIST_MERCHANT_MLE_SUCCESS =
    'FETCH_ENTITY_LIST_MERCHANT_MLE_SUCCESS';
const FETCH_ENTITY_LIST_MERCHANT_MLE_ERROR =
    'FETCH_ENTITY_LIST_MERCHANT_MLE_ERROR';
const RESET_SAVEDATA_SUCCESS_KEY = 'RESET_SAVEDATA_SUCCESS_KEY';
const RETRY_FAILED_MERCHANT_FORM_REQUEST = 'RETRY_FAILED_MERCHANT_FORM_REQUEST';
const RETRY_FAILED_MERCHANT_FORM_SUCCESS = 'RETRY_FAILED_MERCHANT_FORM_SUCCESS';
const RETRY_FAILED_MERCHANT_FORM_ERROR = 'RETRY_FAILED_MERCHANT_FORM_ERROR';
const RESET_RETRY_FORM_STORE = 'RESET_RETRY_FORM_STORE';
const SHOW_ENTITY_HIERARCHY_LOADER = 'SHOW_ENTITY_HIERARCHY_LOADER';
const HIDE_ENTITY_HIERARCHY_LOADER = 'HIDE_ENTITY_HIERARCHY_LOADER';

const SUBMIT_STEP_FORM_REQUEST = 'SUBMIT_STEP_FORM_REQUEST';
const SUBMIT_STEP_FORM_SUCCESS = 'SUBMIT_STEP_FORM_SUCCESS';
const SUBMIT_STEP_FORM_ERROR = 'SUBMIT_STEP_FORM_ERROR';
const FETCH_BD_INPROGRESS_MERCHANT_REQUEST =
    'FETCH_BD_INPROGRESS_MERCHANT_REQUEST';
const FETCH_BD_INPROGRESS_MERCHANT_SUCCESS =
    'FETCH_BD_INPROGRESS_MERCHANT_SUCCESS';
const FETCH_BD_INPROGRESS_MERCHANT_ERROR = 'FETCH_BD_INPROGRESS_MERCHANT_ERROR';
const RESET_FORM_INPROCESS_DATA = 'RESET_FORM_INPROCESS_DATA';
const ADD_HIERARCHY_DATA = 'ADD_HIERARCHY_DATA';
const REMOVE_HIERARCHY_DATA = 'REMOVE_HIERARCHY_DATA';

export {
    FETCH_ENTITY_REQUEST,
    FETCH_ENTITY_SUCCESS,
    FETCH_ENTITY_ERROR,
    SHOW_MERCHANT_LOADER,
    HIDE_MERCHANT_LOADER,
    FETCH_FORM_DETAILS_REQUEST,
    FETCH_FORM_DETAILS_SUCCESS,
    FETCH_FORM_DETAILS_ERROR,
    FETCH_FORM_IN_PROCESS_REQUEST,
    FETCH_FORM_IN_PROCESS_SUCCESS,
    FETCH_FORM_IN_PROCESS_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS,
    FETCH_ENTITY_LIST_MERCHANT_ERROR,
    FETCH_ENTITY_HIERARCHY_REQUEST,
    FETCH_ENTITY_HIERARCHY_SUCCESS,
    FETCH_ENTITY_HIERARCHY_ERROR,
    SAVE_AND_CONTINUE_REQUEST,
    SAVE_AND_CONTINUE_SUCCESS,
    SAVE_AND_CONTINUE_ERROR,
    CREATE_ENTITY_REQUEST,
    CREATE_ENTITY_SUCCESS,
    CREATE_ENTITY_ERROR,
    FETCH_PAYMENT_MODES_REQUEST,
    FETCH_PAYMENT_MODES_SUCCESS,
    FETCH_PAYMENT_MODES_ERROR,
    SET_UNIQUE_IDENTIFIER_REQUEST,
    SET_UNIQUE_IDENTIFIER_SUCCESS,
    SET_UNIQUE_IDENTIFIER_ERROR,
    FETCH_ENTITY_HIERARCHY_MLE_REQUEST,
    FETCH_ENTITY_HIERARCHY_MLE_SUCCESS,
    FETCH_ENTITY_HIERARCHY_MLE_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_MLE_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_MLE_SUCCESS,
    FETCH_ENTITY_LIST_MERCHANT_MLE_ERROR,
    FETCH_DEFAULT_ROUTING_REQUEST,
    FETCH_DEFAULT_ROUTING_SUCCESS,
    FETCH_DEFAULT_ROUTING_ERROR,
    FETCH_SURCHARGE_SLABS_REQUEST,
    FETCH_SURCHARGE_SLABS_SUCCESS,
    FETCH_SURCHARGE_SLABS_ERROR,
    RESET_SAVEDATA_SUCCESS_KEY,
    SUBMIT_FORM_REQUEST,
    SUBMIT_FORM_SUCCESS,
    SUBMIT_FORM_ERROR,
    RETRY_FAILED_MERCHANT_FORM_REQUEST,
    RETRY_FAILED_MERCHANT_FORM_SUCCESS,
    RETRY_FAILED_MERCHANT_FORM_ERROR,
    RESET_RETRY_FORM_STORE,
    SHOW_ENTITY_HIERARCHY_LOADER,
    HIDE_ENTITY_HIERARCHY_LOADER,
    SUBMIT_STEP_FORM_REQUEST,
    SUBMIT_STEP_FORM_SUCCESS,
    SUBMIT_STEP_FORM_ERROR,
    FETCH_BD_INPROGRESS_MERCHANT_REQUEST,
    FETCH_BD_INPROGRESS_MERCHANT_SUCCESS,
    FETCH_BD_INPROGRESS_MERCHANT_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST,
    RESET_FORM_INPROCESS_DATA,
    ADD_HIERARCHY_DATA,
    REMOVE_HIERARCHY_DATA,
};
